<script>

import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfDonem from "@/models/StrPerfDonem";
export default {
  mixins: [Api, Sabit, StrPerfDonem],
props: {
  duyurular: {
    type: Array,
    required: true,
    default: () => []
  }
},
  data() {
    return {
    };
  },
  components: {
    Loader,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get(this.Id);
    },
    kontrol() {
      this.Get(this.Id);
    },
    TipId() {
      this.tip_filtrele();
    },
  },
  methods: {
  }

};

</script>
<template>
  <Loader>
    <b-modal
      id="StrDuyurular"
      size="xl"
      :title="'Duyurular'"
      title-class="font-18"
      hide-footer
    >



           <ul class="verti-timeline list-unstyled">
          <li class="event-list" v-for="Data in duyurular" :key="Data.Id">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="media">
              <div class="me-3">
                <h5 class="font-size-14">
                  {{ Data.IslemTarihi | formatDateTable }}
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="media-body">
                <h5>{{ Data.Baslik }}</h5>
                <div> {{ Data.Icerik }}</div>
              </div>
            </div>
          </li> 
        </ul> 


    </b-modal>
  </Loader>
</template>
